import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
import { jsPDF as JsPDF } from 'jspdf';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import * as leadActions from "../../actions/leadActions";
// ----------------------------------------------------------------------
 
const DisbursementStage = (props) => {
    const { leadId, id } = useParams();
    const location = useLocation();
    const { actions, usersData, fetchLeadIdDocument, allLeadDocumentByLeadData, userRoleType, isActive, leadInfo, backToLeadHandler, enableCamDetailsHandler,fetchLeads, leadFieldPermissions } = props;

    // Disbursement Stage add/edit permissions
    const hasAddPermission = !!leadFieldPermissions?.disbursement_stage?.add;
    const hasEditPermission = !!leadFieldPermissions?.disbursement_stage?.edit;
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    const navigate = useNavigate();

    const [allUsers, setAllUsers] = useState([]);
    const [selectedDocumentFiles, setSelectedDocumentFiles] = useState([]);
    const [getLeadId, setLeadId] = useState('');
    const [allUploadLeadDocument, setAllUploadLeadDocument] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const formRef = useRef(null);
    const [propLeadId, setPropLeadId] = useState('');
    const [allDocumentTypeData, setAllDocumentTypeData] = useState([]);
    const [open, setOpen] = useState(false);
    const [viewModalInfo, setViewModalInfo] = useState([]);
    const [isVerifyDocChecked, setIsVerifyDocChecked] = useState(false);

    const [activeAllSancationDocs, setActiveAllSancationDocs] = useState([]);
    const [allLeadCheckLists, setAllLeadCheckLists] = useState([]);
    const [activeAccordionSections, setActiveAccordionSections] = useState([]);

    
    const [addedLeadCoapplicantGuarantorRows, setAddedLeadCoapplicantGuarantorRows] = useState([]);
    const [coapplicantGuarantorRows, setCoapplicantGuarantorRows] = useState([]);
    const [accountTypeArr, setAccountTypeArr] = useState([]);
    const [crifDetails, setCrifDetails] = useState([]);
    const [bankDetails, setBankDetails] = useState([]);
    const [camApprovalHistory, setCamApprovalHistory] = useState([]);

    const [cAMMarginMoney, setCAMMarginMoney] = useState(0);
    const [annualIrr, setAnnualIrr] = useState(null);
    const [error, setError] = useState(null);
    const [showSanctionNote, setShowSanctionNote] = useState('');
    const [sanctionApproveLatestStatus, setSanctionApproveLatestStatus] = useState(0);
    const [sanctionApproveAndSendMailLatestStatus, setSanctionApproveAndSendMailLatestStatus] = useState(0);
    const [uploadBtnAction, setUploadBtnAction] = useState(0);
    const [sendEmailBtnAction, setSendEmailBtnAction] = useState(0);
    const [openRejectAmt, setOpenRejectAmt] = useState(false);
    const [proposedRejectAmt, setproposedRejectAmt] = useState('');
    const [noOfAssetsToBeFinancedAfter, setNoOfAssetsToBeFinancedAfter] = useState('');
    const [multiofTotalAssetsNoofAssets, SetMultiofTotalAssetsNoofAssets] = useState('');

    const [isFIOpen, setIsFIOpen] = useState(false);
    const [isSanctionLetterPendingItemsOpen, setIsSanctionLetterPendingItemsOpen] = useState(false);
    const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);
    const [isAgreementOpen, setIsAgreementOpen] = useState(false);
    const [isGuarantorOpen, setIsGuarantorOpen] = useState(false);
    const [isMarginMoneyOpen, setIsMarginMoneyOpen] = useState(false);
    const [isDeliveryPhotoOpen, setIsDeliveryPhotoOpen] = useState(false);
    const [isDisbursementOpen, setIsDisbursementOpen] = useState(false);
    const [isVehicleDedupeOpen, setIsVehicleDedupeOpen] = useState(false);
    const [isPostDatedChequeOpen, setIsPostDatedChequeOpen] = useState(false);


    const [sanctionFormStatus, setSanctionFormStatus] = useState(false);
    const [enableUpdatePdfDetails, setEnableUpdatePdfDetails] = useState(false);
    const [refNo, setRefNo] = useState('');
    const [insuranceFor, setInsuranceFor] = useState('For insurance by ckers');
    const [dealerSubvention, setDealerSubvention] = useState('Dealer Subvention');

    const [insuranceForValue, setInsuranceForValue] = useState('');
    const [dealerSubventionValue, setDealerSubventionValue] = useState('');

    const [loanAmountValue, setLoanAmountValue] = useState('');
    const [processingFeeOnFinanceAmountPlusGSTValue, setProcessingFeeOnFinanceAmountPlusGSTValue] = useState('');
    const [lessProcessingFeeIncludingGSTValue, setLessProcessingFeeIncludingGSTValue] = useState('');
    const [lessInsuranceByKotakMahindraValue, setLessInsuranceByKotakMahindraValue] = useState('');

    const [lessPreEmiTill5THJanValue, setLessPreEmiTill5THJanValue] = useState('');
    const [fileChargeValue, setFileChargeValue] = useState('');

    const [netDisbursementValue, setNetDisbursementValue] = useState('');
    const [nameOfSupplierDealerValue, setNameOfSupplierDealerValue] = useState('');

    const [exShowroomPriceValue, setExShowroomPriceValue] = useState('');
    const [insuranceAmounByDealerValue, setInsuranceAmounByDealerValue] = useState('');
    const [totalOnRoadPriceValue, setTotalOnRoadPriceValue] = useState('');
    const [assetValueVehicleVehcilesValue, setAssetValueVehicleVehcilesValue] = useState('');
    const [noOfAssetValue, setNoOfAssetValue] = useState('');
    const [totalDownPaymentByCustomerValue, setTotalDownPaymentByCustomerValue] = useState('');
 
    const [sourceDealerDetails, setSourceDealerDetails] = useState(`1. Complete and filled application form required.2.<br />E-Nach activation confirmation required before disbursal.<br />3. Down Payment proof required.<br />4. All KYC self-attested and OSV done required.<br />5. Disbursement required.<br />6. Zero Depreciation Insurance required before disbursal (Insurance IDV equal and more than loan amount. 1% deviation is acceptable due to market conditions).<br />7. Applicant clear KYC and Banking required with OSV before disbursal.`);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [leadCity, setLeadCity] = useState('');
    const [leadName, setLeadName] = useState('');
    const [leadAddress, setLeadAddress] = useState('');
    const [camDetails, setCamDetails] = useState([]);
    const [savedSanctionDetailsInfo, setSavedSanctionDetailsInfo] = useState([]);
    const [enachItem, setEnachItem] = useState([]);
    const [openAmt, setOpenAmt] = useState(false);
    const [preloaderStatus, setPreloaderStatus] = useState(false);

    const docViewUrl = `${config.API_BASE_URL}uploads/finbox_bank_statements/`;
    const [viewUPIModulePermissionStatus, setViewUPIModulePermissionStatus] = useState(false);
    const [isCamChecked, setIsCamChecked] = useState(false);
    const [showLeadDetails, setShowLeadDetails] = useState(false);
    const [allLeads, setAllLeads] = useState([]);
    const [proposedAmt, setProposedAmt] = useState('');
    const [proposedDebitDate, setProposedDebitDate] = useState('');
    const [showSubmitForDisbursementNote, setShowSubmitForDisbursementNote] = useState(""); 
    const [showDisbursedNote, setShowDisbursedNote] = useState("");

    useEffect(() => {
        
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        if (authToken === null) {
            navigate('/login');
        }

        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        actions.usersData(requestData);
        if (usersData.success) {
            setAllUsers(usersData.data);
        }
    }, []);

    const formattedDate = currentDate.toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    });

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const formatDateForValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }

        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');

        return `${day}-${month}-${year}`;
    };


    const clickCcmTab = () => {
        backToLeadHandler('cam');
        enableCamDetailsHandler(true);
        const timer = setTimeout(() => {
            const divElement = document.getElementById("pills-disbursement_memo-tab");
            if (divElement) {
                divElement.click();
            }
        }, 2000);
        return () => clearTimeout(timer);
    };

    useEffect(() => {
        if (leadInfo?.data?.length > 0) {

            const name = leadInfo.data[0]?.name;
            setLeadName(name);

            const city = leadInfo.data[0]?.city;
            setLeadCity(city);

            const fullAddress = leadInfo.data[0]?.full_address;
            setLeadAddress(fullAddress);

            console.log("lead info - ", leadInfo?.data);

             if (
                Object.prototype.hasOwnProperty.call(
                  leadInfo.data[0],
                  "submitForDisbursementInfo"
                )
              ) {
                if (  leadInfo.data[0].submitForDisbursementInfo !== null &&
                  Object.prototype.hasOwnProperty.call(
                    leadInfo.data[0]?.submitForDisbursementInfo,
                    "created_date"
                  ) &&
                  leadInfo.data[0]?.submitForDisbursementInfo.created_date
                ) {
                  const note = `Submit For Disbursement On ${leadInfo.data[0]?.submitForDisbursementInfo.created_date} `;
                  setShowSubmitForDisbursementNote(note); 
                  
                } 
              }

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfo.data[0],
                  "disbursedInfo"
                )
              ) {
                if ( leadInfo.data[0].disbursedInfo !== null &&
                  Object.prototype.hasOwnProperty.call(
                    leadInfo.data[0].disbursedInfo,
                    "created_date"
                  ) &&
                  leadInfo.data[0]?.disbursedInfo?.created_date
                ) {
                  const note = `Disbursed On ${leadInfo.data[0]?.disbursedInfo?.created_date} `;
                  setShowDisbursedNote(note); 
                  
                } 
              }
        }

    }, [leadInfo]);


    const getSanctionConfigData = async (action = '', notes = '') => {

        let actionStatus = '0';
        let submitStatus = true;

        if (action === 'approve') {
            actionStatus = '1';
            if (notes === '') {
                toast.error("Notes is required.", {
                    position: "top-right",
                });
                submitStatus = false;
            }
        } else if (action === 'reject') {
            actionStatus = '2';

            if (notes === '') {
                toast.error("Notes is required.", {
                    position: "top-right",
                });
                submitStatus = false;
            }
        } else if (action === 'reversal') {
            actionStatus = '3';

            if (notes === '') {
                toast.error("Notes is required.", {
                    position: "top-right",
                });
                submitStatus = false;
            }

        }

        if (submitStatus) {
            if (id !== undefined) {
                setPropLeadId(atob(id));
                setLeadId(propLeadId);
                let readyToSubmit = true;

                const additionalDetails = { } 

                let obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id), "action_status": actionStatus, 'notes': notes, "sendEmail": sendEmailBtnAction, "additionalDetails": additionalDetails, 'api_calling_module': "disbursement_stage" };
                if (enableUpdatePdfDetails) {

                    if (refNo === '') {
                        toast.error("Ref No is required.", {
                            position: "top-right",
                        });
                        readyToSubmit = false;
                    } else if (sourceDealerDetails === '') {
                        toast.error("Source dealer details is required.", {
                            position: "top-right",
                        });
                        readyToSubmit = false;
                    }

                    obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id), 'sourceDealerDetails': sourceDealerDetails, "refNo": refNo, "enableUpdatePdfDetails": enableUpdatePdfDetails, "action_status": actionStatus, 'notes': notes, "sendEmail": sendEmailBtnAction, "additionalDetails": additionalDetails, 'api_calling_module': "disbursement_stage" };
                }

                if (readyToSubmit) {
                    // console.log("obj lead id- ", obj);
                    const requestData = encryptData(obj);
                    const response = actions.getSanctionConfigData(requestData);

                    response.then((result) => {
                        setOpenRejectAmt(false);
                        setUploadBtnAction(0);
                        setSendEmailBtnAction(0);
                        // console.log("Promise resolved -  source data:", result); 
                        if (result.data.success === 1) {
                            const resultArr = result.data.data;


                            const uniqueDocSections = [...new Set(resultArr.activeAllSancationDocs.map(doc => doc.doc_section))];

                            console.log(" ---- setActiveAccordionSections", uniqueDocSections);

                            setActiveAccordionSections(uniqueDocSections);

                            setActiveAllSancationDocs(resultArr.activeAllSancationDocs);

                            // get lead assigned checklists
                            const checkListsResults = resultArr?.all_checklists;
                            const checkListsResultsArr = Object.keys(checkListsResults).map(
                                (key) => checkListsResults[key]
                            );
                            setAllLeadCheckLists(checkListsResultsArr);
                            // alert('here');
                            const sanctionDetailsInfo = resultArr?.sanction_details_info;

                            setSavedSanctionDetailsInfo(sanctionDetailsInfo);
                            if (sanctionDetailsInfo !== null) {

                                console.log("sanctionDetailsInfo?.additionalDetails = ", sanctionDetailsInfo?.additionalDetails);
                                if (sanctionDetailsInfo?.additionalDetails) {
                                    const parsedData = JSON.parse(sanctionDetailsInfo?.additionalDetails);
                                }

                                if (sanctionDetailsInfo?.refNo) {
                                    setRefNo(sanctionDetailsInfo.refNo);
                                }
                                if (sanctionDetailsInfo?.sourceDealerDetails) {
                                    setSourceDealerDetails(sanctionDetailsInfo.sourceDealerDetails);

                                }

                            }


                            if (enableUpdatePdfDetails) {
                                setEnableUpdatePdfDetails(false);
                            }
                        }

                        getCAMDetailsData();
                    }).catch((error) => {
                        //  console.error("Promise rejected -  source data :", error); 
                    });
                }
            }
        }

    };

    const getCAMDetailsData = async () => {
        if (!id) {
            console.error("Error: ID is undefined.");
            return;
        }

        try {
            const decodedId = atob(id);

            const obj = {
                start: '0',
                length: config.MAX_RECORDS,
                lead_id: decodedId,
                with_additional_info: 'yes'
            };

            setCoapplicantGuarantorRows(addedLeadCoapplicantGuarantorRows);
            const requestData = encryptData(obj);
            const result = await actions.getCAMDetails(requestData);

            if (result?.data?.success === 1) {
                const results = result.data.data?.data || {};
                const resultArr = Object.values(results);

                if (resultArr?.length > 0 && resultArr[0]?.cam_details) {
                    const camDetails = resultArr[0].cam_details;
                    const jsonData = JSON.parse(camDetails);

                    if (jsonData?.dob === '0000-00-00') {
                        jsonData.dob = '';
                    }

                    setCamDetails(jsonData);
                    setRefNo(jsonData?.dmemo_reference_no);
                    if (jsonData?.coapplicantGuarantorDetails) {
                        setCoapplicantGuarantorRows(jsonData.coapplicantGuarantorDetails);
                        // setAddedLeadCoapplicantGuarantorRows

                    }

                    console.log("savedSanctionDetailsInfo = ", savedSanctionDetailsInfo);


                }

            }
        } catch (error) {
            // console.error("Error in getCAMDetailsData:", error);
        }
    };

    const getUploadLeadDocumentData = async () => {
        if (id !== undefined) {
            setPropLeadId(atob(id));
            setLeadId(propLeadId);

            const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id), 'api_calling_module': "disbursement_stage" };
            // console.log("obj lead id- ", obj);
            const requestData = encryptData(obj);
            const response = actions.getUploadLeadDocument(requestData);

            response.then((result) => {
                // console.log("Promise resolved -  source data:", result); 
                if (result.data.success === 1) {
                    const results = result.data.data.data;
                    const resultArr = Object.keys(results).map((key) => results[key]);

                    // console.log("AllUploadLeadDocument = ",resultArr);
                    // alert('here');

                    setAllUploadLeadDocument(resultArr);
                }
            }).catch((error) => {
                //  console.error("Promise rejected -  source data :", error); 
            });
        }
    };

    useEffect(() => {
        if (isActive) {
            getSanctionConfigData();
            getUploadLeadDocumentData();
        }
    }, [isActive]);

    /* useEffect(() => {
         if (id !== undefined) {
             getUploadLeadDocumentData(); 
         }
     }, [setAllUploadLeadDocument]); */

    useEffect(() => {
        if (id !== undefined) {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id) };
        const requestData = encryptData(obj);
        const response = actions.masterDocumentTypeData(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  source data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data.data
                const filteredResultArr = results.filter((item) => item.status === "1");
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.document_type.localeCompare(b.document_type)
                );
                setAllDocumentTypeData(sortedResultArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
        });
    }

    }, [setAllDocumentTypeData]);

    const handleDocumentFileChange = (e) => {
        const files = Array.from(e.target.files);
        const base64Files = [];

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Data = event.target.result;
                const fileName = file.name;
                base64Files.push({ file: base64Data, name: fileName });
                if (base64Files.length === files.length) {
                    setSelectedDocumentFiles(base64Files);
                }
            };
            reader.readAsDataURL(file);
        });
    };



    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const filteredItems = (allUploadLeadDocument ?? []).filter(item =>
        item.formatetdID.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.assignedUser.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.statusName.toLowerCase().includes(searchQuery.toLowerCase())
    );


    const startIndex = (currentPage - 1) * config.ITEMS_PER_PAGE;
    const endIndex = startIndex + config.ITEMS_PER_PAGE;
    const paginatedItems = filteredItems.slice(startIndex, endIndex);
    const totalPages = Math.ceil(filteredItems.length / config.ITEMS_PER_PAGE);

    const onRowClickAction = (itemObj, btnAction) => {
        setViewModalInfo(itemObj);
        setOpen(true);
    }

    const veridateDoc = (data, actionStatus) => {

        const verifyDocStatus = (actionStatus) ? 1 : 0;
        const params = { "id": data.id, "status": verifyDocStatus, "params": data };

        const requestData = encryptData(params);
        const response = actions.verifyDocuments(requestData);
        response.then((result) => {
            if (result.data.success === 1) {
                toast.success(result.data.message, {
                    position: "top-right",
                });
                getUploadLeadDocumentData();
            } else {
                toast.error(result.data.message, {
                    position: "top-right",
                });
            }
        }).catch((error) => {
            toast.error(error, {
                position: "top-right",
            });
        });
    };

    const handleVerifyAction = (event, item) => {
        setIsVerifyDocChecked(event.target.checked)
        veridateDoc(item, event.target.checked);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleToggle = () => {
        setSanctionFormStatus(prevState => !prevState);
        getSanctionConfigData();
    }

    const handleToggleUpdateDetails = () => {
        setEnableUpdatePdfDetails(prevState => !prevState);
    }

    const handleToggleSaveDetails = () => {
        getSanctionConfigData();
    }

    const handleSourceDealerChange = (event) => {
        setSourceDealerDetails(event.target.value);
    }

    const btnOpenUploadMissingData = (item) => {
        setOpenAmt(true);
        setEnachItem(item);
    }


    const [htmlContent, setHtmlContent] = useState('');
    const editorRef = useRef(null);


    const handleInput = () => {
        setHtmlContent(editorRef.current.innerHTML);
    };

    const [formRejectitem, setFormRejectitem] = useState({
        notes: '',
    });

    const btnUploadHandler = (btnAction, sendEmail = '0') => {    // buttonFun 
        setUploadBtnAction(btnAction);
        setOpenRejectAmt(true);
        setSendEmailBtnAction(sendEmail);
    };

    const handleCloseRejectAmt = () => {     // Modal onclick closedFun
        setUploadBtnAction(0);
        setOpenRejectAmt(false);
        setSendEmailBtnAction(0);
    };


    const checkDocumentType = (data) => {
        return data.startsWith("dynamicDocument^");
    };

    const handleDocumentsFormSubmit = (data) => {

        setPropLeadId(atob(id));
        setLeadId(propLeadId);

        let documentTypeName = '';
        let documentTypeStatus = 'static';
        if (data.document_type === undefined) {
            documentTypeName = '';
        } else {
            const docTypeOption = allDocumentTypeData.find(doc => doc.id === data.document_type);
            console.log("docTypeOption = ", docTypeOption);
            documentTypeName = docTypeOption?.document_type;
            const checkStatus = checkDocumentType(data.document_type);
            if (checkStatus) {
                documentTypeStatus = 'dynamic';
            }
        }

        if (data.document_type.trim() === "") {
            toast.error("No document type has been selected.", {
                position: "top-right",
            });
        } else if (!selectedDocumentFiles || selectedDocumentFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else if (data.document_note.trim() === "") {
            toast.error("Note is blank.", {
                position: "top-right",
            });
        } else if (data.registration_no.trim() === "" && uploadBtnAction === 'MSME Certificate') {
            toast.error("Registration No is blank.", {
                position: "top-right",
            });

        } else if (data.vehicle_dedupe_no.trim() === "" && uploadBtnAction === 'Vehicle Dedupe') {
            toast.error("No is blank.", {
                position: "top-right",
            }); 
            
         } else if (data.cheque_no.trim() === "" && uploadBtnAction === 'Post Dated Cheque') {
            toast.error("No is blank.", {
                position: "top-right",
            }); 
          } else if (data.cheque_account_no.trim() === "" && uploadBtnAction === 'Post Dated Cheque') {
            toast.error("Account number is blank.", {
                position: "top-right",
            });           
        } else {

            if (uploadBtnAction !== 'MSME Certificate') {
                data.registration_no = '';
            }

            if (uploadBtnAction !== 'Vehicle Dedupe') {
                data.vehicle_dedupe_no = '';
            }

            if (uploadBtnAction !== 'Post Dated Cheque') {
                data.cheque_no = '';
                data.cheque_account_no = ''; 
            }

            const params = { "lead_id": propLeadId, "document_type": data.document_type, "document_note": data.document_note, "document_file": selectedDocumentFiles, "uploadBtnAction": uploadBtnAction, "registration_no": data.registration_no, "documentTypeName": documentTypeName, "documentTypeStatus": documentTypeStatus ,"vehicle_dedupe_no" : data.vehicle_dedupe_no ,"cheque_no" : data.cheque_no ,"cheque_account_no" : data.cheque_account_no};

            const requestData = encryptData(params);
            const response = actions.addEditLeadDocument(requestData, navigate);

            response.then((result) => {
                // console.log("Promise resolved - addEditLeadDocument form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });

                    const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": propLeadId };
                    // console.log("obj lead id- ", obj);
                    const requestData = encryptData(obj);
                    const response = actions.getUploadLeadDocument(requestData);

                    response.then((result) => {
                        // console.log("Promise resolved -  source data:", result); 
                        if (result.data.success === 1) {
                            const results = result.data.data.data;
                            const resultArr = Object.keys(results).map((key) => results[key]);


                            setAllUploadLeadDocument(resultArr);
                        }
                    }).catch((error) => {
                        //  console.error("Promise rejected -  source data :", error); 
                    });

                    reset();
                    setSelectedDocumentFiles("");
                    getSanctionConfigData();
                    getUploadLeadDocumentData();
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    }

    const handleAmtRejectChange = (e) => {
        const totalAmt = e.target.value;
        setFormRejectitem((prevState) => ({
            ...prevState,
            totalAmt,
        }));
    }

    const printRef = useRef();
    const handleDownloadPdf = async () => {
        const element = printRef.current;
        if (!element) {
            console.error('Element not found');
            return;
        }
        const canvas = await html2canvas(element);
        if (canvas.width === 0 || canvas.height === 0) {
            console.error('Captured canvas has invalid dimensions');
            return;
        }
        const data = canvas.toDataURL('image/png');
        const pdf = new JsPDF();
        const imgProperties = pdf.getImageProperties(data);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

        pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);
        const timestamp = new Date().toISOString();
        const filename = `disbursement_stage_${timestamp}.pdf`;
        pdf.save(filename);
    };


    const toggleSection = (tabName) => {

        //  alert(tabName);

        if (tabName === 'FI') {
            setIsFIOpen(!isFIOpen);
        }

        if (tabName === 'Sanction Letter Pending Items') {
            setIsSanctionLetterPendingItemsOpen(!isSanctionLetterPendingItemsOpen);
        }

        if (tabName === 'Delivery Order Pending Items') {
            setIsAgreementOpen(!isAgreementOpen);
        }

        if (tabName === 'Invoice') {
            setIsInvoiceOpen(!isInvoiceOpen);
        }

        if (tabName === 'Margin Money') {
            setIsMarginMoneyOpen(!isMarginMoneyOpen);
        }


        if (tabName === 'Delivery Photo') {
            setIsDeliveryPhotoOpen(!isDeliveryPhotoOpen);
        }
         if (tabName === 'Post Dated Cheque') {
            setIsPostDatedChequeOpen(!isVehicleDedupeOpen);
        }
        if (tabName === 'Vehicle Dedupe') {
            setIsVehicleDedupeOpen(!isVehicleDedupeOpen);
        }       

        if (tabName === 'Disbursement') {
            setIsDisbursementOpen(!isDisbursementOpen);
        }

        
    };

    // UPI REGISTRATION START 
    // const [enchUPIitem, setEnachUPIitem] = useState([]);
    const [enchUPIitem, setEnachUPIitem] = useState({
        totalAmt: '',
        upiDebitDate: '',
    });

    const [openUPIAmt, setOpenUPIAmt] = useState(false);
    const [proposedUPIAmt, setproposedUPIAmt] = useState('');

    const btnOpenUPIData = (item) => {    // buttonFun
        setOpenUPIAmt(true);
        setEnachUPIitem(item);
        console.log("item Details 123", item);
    };

    const handleCloseUPIAmt = () => {     // Modal onclick closedFun
        setOpenUPIAmt(false);
        setEnachUPIitem([]);
    };

    const handleAmtUPIChange = (e) => {
        const totalAmt = e.target.value;
        setEnachUPIitem((prevState) => ({
            ...prevState,
            totalAmt,
        }));
    }

    const handleUPIDateChange = (e) => {
        const upiDebitDate = e.target.value;
        setEnachUPIitem((prevState) => ({
            ...prevState,
            upiDebitDate,
        }));
    }

    const handleUPIFormSubmit = (data) => {
        console.log("ModalUPIHandle", data.emi_amount1);

        if (data.emi_amount1 === '') {
            toast.error("UPI Amount is required.", {
                position: "top-right",
            });
        } else if (data.debit_date1 === '') {
            toast.error("UPI Debit date is required.", {
                position: "top-right",
            });
        } else {
            enchUPIitem.totalAmt = data.emi_amount1;
            enchUPIitem.upiDebitDate = data.debit_date1;
            console.log("Updated enchUPIitem: ", enchUPIitem);
            onsendUPIRegistrationAction(enchUPIitem);
        }
    }

    const onsendUPIRegistrationAction = (item) => {
        setPreloaderStatus(true);

        // alert(item.emi_amount);
        const params = { 'lead_id': atob(id), 'application_id': atob(id), 'brief': 'send_sms_to_user', 'action': 'send_upi_link_to_user', 'call_api_from': 'Lead', 'proposed_debit_date': item.upiDebitDate, 'proposed_amount': item.totalAmt, 'api_response': enchUPIitem };
        console.log("onsendUPIRegitrationDataShowParams", params);
        const requestData = encryptData(params);
        const response = actions.sendEnachUPIRegistrationDetails(requestData);
        response.then((result) => {
            if (result.data.success === 1) {
                console.log("response = ", result.data.data);
                setPreloaderStatus(false);
                toast.success(result.data.message, {
                    position: "top-right",
                });
                const obj = {
                    'start': '0', 'length': config.MAX_RECORDS, "user_role_type": userRoleType,
                    "is_cam_leads": isCamChecked
                };
                const requestData = encryptData(obj);
                const response = actions.leadsData(requestData);
                response.then((result) => {
                    console.log("Promise resolved -  lead list:", result);
                    if (result.data.success === 1) {
                        setShowLeadDetails(true);
                        const results = result.data.data.data;
                        const resultArr = Object.keys(results).map((key) => results[key]);
                        setAllLeads(resultArr);
                        handleCloseUPIAmt();
                    }
                }).catch((error) => {
                    console.error("Promise rejected -  lead list:", error);
                });

            } else {
                setPreloaderStatus(false);
                toast.error(result.data.message, {
                    position: "top-right",
                });
            }

            setOpenAmt(false);
            setProposedAmt('');
            setProposedDebitDate('');
            setEnachItem([]);

            reset();
            setSelectedDocumentFiles("");
            getSanctionConfigData();
            getUploadLeadDocumentData();
        }).catch((error) => {
            setPreloaderStatus(false);
            toast.error(error, {
                position: "top-right",
            });
        });

    };

    // UPI REGISTRATION END


    const handleAmtChange = (e) => {
        const amt = e.target.value;
        setProposedAmt(amt);
    };

    const handleDebitDateChange = (e) => {
        const date = e.target.value;
        setProposedDebitDate(date);
    };

    const handleCamChange = (event) => {
        setIsCamChecked(event.target.checked);
    };

    const handleCloseAmt = () => {
        setOpenAmt(false);
        // setProposedAmt('');
        // setProposedDebitDate('');
        setEnachItem([]);
    };

    const onSendEnachRegistrationAction = (item) => {
        setPreloaderStatus(true);

        // alert(item.emi_amount);
        const params = { 'lead_id': atob(id), 'application_id': atob(id), 'brief': 'send_sms_to_user', 'action': 'send_enach_link_to_user', 'call_api_from': 'Lead', 'proposed_amount': item.emi_amount, 'proposed_debit_date': item.debit_date };
        const requestData = encryptData(params);
        const response = actions.sendEnachRegistrationDetails(requestData);

        response.then((result) => {
            // console.log("Promise resolved - add/edit lead form:", result);

            if (result.data.success === 1) {
                console.log("response = ", result.data.data);
                setPreloaderStatus(false);
                toast.success(result.data.message, {
                    position: "top-right",
                });
            } else {
                setPreloaderStatus(false);
                toast.error(result.data.message, {
                    position: "top-right",
                });
            }

            setOpenAmt(false);
            setProposedAmt('');
            setProposedDebitDate('');
            setEnachItem([]);

            reset();
            setSelectedDocumentFiles("");
            getSanctionConfigData();
            getUploadLeadDocumentData();
        }).catch((error) => {
            setPreloaderStatus(false);
            toast.error(error, {
                position: "top-right",
            });
        });

    };

    const handleFormSubmit = (data) => {
        console.log("handleFormSubmit , ", data);

        if (data.emi_amount === '') {
            toast.error("Amount is required.", {
                position: "top-right",
            });
        } else if (data.debit_date === '') {
            toast.error("Debit date is required.", {
                position: "top-right",
            });
        } else {

            // setProposedAmt(data.emi_amount);
            // setProposedDebitDate(data.debit_date);
            enachItem.emi_amount = data.emi_amount;
            enachItem.debit_date = data.debit_date;
            onSendEnachRegistrationAction(enachItem);
        }

    }

     function handleBtnCredit(actionName) {
        const params = { lead_id: atob(id), "action" : actionName , "userRoleType" :userRoleType };
        // console.log("handleBtnCredit = ", params);
        const requestData = encryptData(params);
        const response = actions.addCredit(requestData);
        response
          .then((result) => {
            // console.log("Promise resolved - add/edit lead form:", result);
            if (result.data.success === 1) {
              toast.success(result.data.message, {
                position: "top-right",
              });
              const addCreditInfo = result.data.data;
              if (addCreditInfo !== "") {
                if (
                  Object.prototype.hasOwnProperty.call(
                    addCreditInfo,
                    "created_date"
                  )
                ) {
    
                  
                  if(actionName === 'submit_for_disbursement'){
    
                    const showResNote = `Submit For Disbursement On ${addCreditInfo.created_date} `;
                     setShowSubmitForDisbursementNote(showResNote);    
                  } 

                   if(actionName === 'disbursed'){
    
                    const showResNote = `Disbursed On ${addCreditInfo.created_date} `;
                     setShowDisbursedNote(showResNote);    
                  } 
                }
                fetchLeads();
              }
            } else {
              toast.error(result.data.message, {
                position: "top-right",
              });
            }
          })
          .catch((error) => {
            // console.error("Promise rejected - add/edit lead form:", error);
            toast.error(error, {
              position: "top-right",
            });
          });
      }

    return (
        <>
            <div id="main-wrap" className='mt-4'>
                <div className='row justify-content-between'>
                    <h5 className="fw-bold">Disbursement Stage</h5>


                    <div className="">


                        <div className='row'>
                            {activeAccordionSections.map((sectionInfo, sectionIndex) => {
                                const matchingDocs = activeAllSancationDocs.filter(
                                    (doc) => doc.doc_section === sectionInfo
                                );
                                let isOpenSection = false;
                                if (sectionInfo === 'Sanction Letter Pending Items') {
                                    isOpenSection = isSanctionLetterPendingItemsOpen;
                                }

                                if (sectionInfo === 'Delivery Order Pending Items') {
                                    isOpenSection = isAgreementOpen;
                                }


                                if (sectionInfo === 'Invoice') {
                                    isOpenSection = isInvoiceOpen;
                                }


                                if (sectionInfo === 'Margin Money') {
                                    isOpenSection = isMarginMoneyOpen;
                                }

                                if (sectionInfo === 'Delivery Photo') {
                                    isOpenSection = isDeliveryPhotoOpen;
                                }
                                 if (sectionInfo === 'Post Dated Cheque') {
                                    isOpenSection = isPostDatedChequeOpen;
                                }

                                 if (sectionInfo === 'Vehicle Dedupe') {
                                    isOpenSection = isVehicleDedupeOpen;
                                } 
                               
                                if (sectionInfo === 'Disbursement') {
                                    isOpenSection = isDisbursementOpen;
                                } 

                                return (
                                    <div key={sectionIndex} className="col-md-12">
                                        <div className={(sectionInfo === 'Sanction Letter Pending Items' || sectionInfo === 'Delivery Order Pending Items') ? "collapsible-section-red" : "collapsible-section"}>

                                            <button
                                                className={(sectionInfo === 'Sanction Letter Pending Items' || sectionInfo === 'Delivery Order Pending Items') ? "section-header-red btn-noborder" : "section-header btn-noborder"}
                                                onClick={() => toggleSection(sectionInfo)}
                                            >
                                                <h5>{sectionInfo}</h5>
                                                <span>{isFIOpen ? '-' : '+'}</span>
                                            </button>
                                            {isOpenSection && (
                                                <div className="section-content" style={(sectionInfo === 'Sanction Letter Pending Items' || sectionInfo === 'Delivery Order Pending Items')
                                                    ? { borderTop: "1px solid #f03d3d", padding: "30px 10px 10px 10px" }
                                                    : { borderTop: "1px solid #86bcb9", padding: "30px 10px 10px 10px" }
                                                }>


                                                    {matchingDocs.map((docInfo, index) => {
                                                        // Find the matching document in allUploadLeadDocument
                                                        const matchedDoc = allUploadLeadDocument.find((item) => item.documentTypeName === docInfo.doc_name);
                                                        return (
                                                            <>
                                                                {(matchedDoc) ? (
                                                                    <>
                                                                        {(sectionInfo === 'Sanction Letter Pending Items' || sectionInfo === 'Delivery Order Pending Items') ?
                                                                            (<>
                                                                                {matchedDoc.verified_status !== "1" && (
                                                                                    <>
                                                                                        <div key={index} className="col-md-12 mb-3 row">
                                                                                            <div className="col-md-4" title="section 1">
                                                                                                <b>{docInfo.doc_name}</b>
                                                                                            </div>
                                                                                            <div className="col-md-4">
                                                                                                <span className="text-danger">NOT VERIFIED</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </>) :
                                                                            (
                <>
                    <div key={index} className="col-md-12 mb-3 row">

                        <div className="col-md-4" title={`section 2 ${matchedDoc.id}`}>
                            <b>{docInfo.doc_name}</b>
                        </div>
                        {(matchedDoc.document !== '') && (
                            <>
                                <div className="col-md-4">
                                    <a target="new"
                                        href={(sectionInfo === 'Invoice' || sectionInfo === 'Agreement') ? matchedDoc.document : matchedDoc.document} className="text-decoration-none">
                                        Download File
                                    </a>
                                    &nbsp; Uploaded On {matchedDoc.created_date} by {matchedDoc.createdByName}

                                    {sectionInfo === 'Vehicle Dedupe' && (
                                        <>
                                            {matchedDoc?.vehicle_dedupe_no !=='' && (
                                                <>
                                                <br/>{matchedDoc?.document_type} - {matchedDoc?.vehicle_dedupe_no}
                                                </>
                                            )}
                                        </>
                                    )} 

                                     {sectionInfo === 'Post Dated Cheque' && (
                                        <>
                                            {matchedDoc?.cheque_no !=='' && (
                                                <>
                                                <br/>Cheque No - {matchedDoc?.cheque_no}
                                                </>
                                            )}
                                            {matchedDoc?.cheque_account_no !=='' && (
                                                <>
                                                <br/>Account No - {matchedDoc?.cheque_account_no}
                                                </>
                                            )}
                                        </>
                                    )} 
                                </div>
                            </>
                        )}

{matchedDoc.verified_status !== "1" ? (
<>
<div className="col-md-4">
    <span className="text-danger">NOT VERIFIED</span>


    {hasEditPermission && (userRoleType === "Credit" || userRoleType === "Manager" || userRoleType === 'Superadmin' || userRoleType === 'Credit Operations') && (
        <>
            {(matchedDoc.documentTypeStatus === 'dynamic' && matchedDoc.notMatchingDetails !== '') ?
                (
                                                                                                                    <>
                                                                                                                        <span className='float-right'>
                                                                                                                            {matchedDoc.verified_status !== '1' ? (
                                                                                                                                <>
                                                                                                                                    {(matchedDoc.notMatchingDetails !== '') ? JSON.parse(matchedDoc.notMatchingDetails) : ''}
                                                                                                                                </>
                                                                                                                            ) : (
                                                                                                                                <></>
                                                                                                                            )}
                                                                                                                        </span>
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <>
                                                                                                                        {matchedDoc.verified_status !== '1' ? (
                                                                                                                            <span className='float-right'>
                                                                                                                                <input type='checkbox' name='document_verify' id='document_verify'
                                                                                                                                    {...register('document_verify')}
                                                                                                                                    onChange={(event) => handleVerifyAction(event, matchedDoc)}
                                                                                                                                /> <b>Verify</b></span>
                                                                                                                        ) : (
                                                                                                                            <> </>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                )}
                                                                                                        </>
                                                                                                    )}
                                                                                                </div>
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <div className="col-md-4">
                                                                                                    <span className='text-green'>Validated On</span> {matchedDoc.validated_date} by {matchedDoc.validatedByName}

                                                                                                    {hasEditPermission && (userRoleType === "Credit" || userRoleType === "Manager" || userRoleType === 'Superadmin' || userRoleType === 'Credit Operations') && (
                                                                                                        <>
                                                                                                            {(matchedDoc.documentTypeStatus === 'dynamic') ?
                                                                                                                (
                                                                                                                    <>
                                                                                                                        <span className='float-right'>
                                                                                                                            {matchedDoc.verified_status !== '1' ? (
                                                                                                                                <>
                                                                                                                                    {(matchedDoc.notMatchingDetails !== '') ? JSON.parse(matchedDoc.notMatchingDetails) : ''}
                                                                                                                                </>
                                                                                                                            ) : (
                                                                                                                                <></>
                                                                                                                            )}
                                                                                                                        </span>
                                                                                                                    </>
                                                                                                                ) : (
                                                                                                                    <>
                                                                                                                        {matchedDoc.verified_status !== '1' ? (
                                                                                                                            <span className='float-right'>
                                                                                                                                <input type='checkbox' name='document_verify' id='document_verify'
                                                                                                                                    {...register('document_verify')}
                                                                                                                                    onChange={(event) => handleVerifyAction(event, matchedDoc)}
                                                                                                                                /> <b>Verify</b></span>
                                                                                                                        ) : (
                                                                                                                            <> </>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                )}
                                                                                                        </>
                                                                                                    )}
                                                                                                </div>
                                                                                            </>
                                                                                        )}


                                                                                    </div>
                                                                                </>)}

                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div key={index} className={(docInfo.doc_name === "eNach" || docInfo.doc_name === 'UPI 2.0') ? "col-md-12 mb-3 row" : "col-md-12 mb-3 row"}>

                                                                            {docInfo.doc_name === "eNach" && docInfo.data.userEnachResponse?.response_status !== "Success" && (() => {
                                                                                let ENachSentStatus = false;
                                                                                let ENachUserStatus = false;
                                                                                let ENachUserHtml = null;
                                                                                let umrnNo = '';
                                                                                if (docInfo?.data?.id) {
                                                                                    ENachSentStatus = true;
                                                                                    if (docInfo?.data?.userEnachResponse?.response_status) {

                                                                                        if (docInfo.data.userEnachResponse.response_status === "Success") {
                                                                                            if (docInfo.data.userEnachResponse?.itcArr?.UMRNNumber !== "") {
                                                                                                umrnNo = <span className="text-success">UMRN Number : {docInfo.data.userEnachResponse?.itcArr?.UMRNNumber}</span>;
                                                                                            }

                                                                                            ENachUserHtml = <div className="text-success" style={{ width: 'auto', float: 'left' }}>E-NACH process successfully done {docInfo?.data?.userEnachResponse?.createdByName !== '' && docInfo?.data?.userEnachResponse?.createdByName !== undefined ? (
                                                                                                <>
                                                                                                    By System
                                                                                                    <br />
                                                                                                    Done on {docInfo?.data?.userEnachResponse?.enach_created_date}
                                                                                                </>
                                                                                            ) : (
                                                                                                ''
                                                                                            )}.</div>;
                                                                                            ENachUserStatus = true;
                                                                                        } else {
                                                                                            ENachUserHtml = <div className="text-danger" style={{ width: 'auto', float: 'left' }}>E-NACH process {docInfo.data.userEnachResponse.response_status}.</div>;
                                                                                        }
                                                                                    }
                                                                                }

                                                                                return (
                                                                                    <>
                                                                                        <div className="col-md-4">
                                                                                            <b style={{ width: 'auto', float: 'left' }}>{docInfo.doc_name} {umrnNo}
                                                                                            </b>
                                                                                        </div>
                                                                                        {ENachSentStatus ? (
                                                                                            <>
                                                                                                <div className="col-md-4">
                                                                                                    <div className="text-success" style={{ width: 'auto', float: 'left' }}>
                                                                                                        SMS link sent successfully
                                                                                                        {docInfo?.data?.createdByName !== '' && docInfo?.data?.createdByName !== undefined ? (
                                                                                                            <>
                                                                                                                By {docInfo?.data?.createdByName}
                                                                                                                <br />
                                                                                                                Done on {docInfo?.data?.enach_created_date}
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            ''
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="col-md-4">
                                                                                                    {ENachUserHtml}
                                                                                                </div>
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <div className="col-md-4">
                                                                                                    <div className="col-md-8">
                                                                                                        {hasAddPermission && (
                                                                                                        <button type="button" className={(ENachUserStatus) ? "d-none badge btn btn-success text-white float-right" : "badge btn btn-success text-white float-right"}
                                                                                                            onClick={(e) => {
                                                                                                                e.preventDefault(); /* onSendEnachRegistrationAction(item) */
                                                                                                                btnOpenUploadMissingData(docInfo)
                                                                                                            }}>
                                                                                                            {preloaderStatus && (<>
                                                                                                                <div className="spinner-border small-preloader d-none" role="status" >
                                                                                                                    <span className="visually-hidden">Loading...</span>
                                                                                                                </div></>)}
                                                                                                            E-NACH Registration
                                                                                                        </button>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                );
                                                                            })()}


                                                                            <>

                                                                                {docInfo.doc_name === "UPI 2.0" && docInfo.data.userUPIResponse?.response_status !== "Success" && (() => {
                                                                                    let UPISentStatus = false;
                                                                                    let UPIUserStatus = false;
                                                                                    let UPIUserHtml = null;
                                                                                    let umrnNo = '';
                                                                                    if (docInfo?.data?.id) {
                                                                                        UPISentStatus = true;
                                                                                        if (docInfo?.data?.userUPIResponse?.response_status) {

                                                                                            if (docInfo.data.userUPIResponse.response_status === "Success") {
                                                                                                if (docInfo.data.userUPIResponse?.itcArr?.UMRNNumber !== "") {
                                                                                                    umrnNo = <span className="text-success">UMRN Number : {docInfo.data.userUPIResponse?.itcArr?.UMRNNumber}</span>;
                                                                                                }

                                                                                                UPIUserHtml = <div className="text-success" style={{ width: 'auto', float: 'left' }}>UPI 2.0 process successfully done {docInfo?.data?.userUPIResponse?.createdByName !== '' && docInfo?.data?.userUPIResponse?.createdByName !== undefined ? (
                                                                                                    <>
                                                                                                        By System
                                                                                                        <br />
                                                                                                        Done on {docInfo?.data?.userUPIResponse?.enach_created_date}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    ''
                                                                                                )}
                                                                                                    .</div>;
                                                                                                UPIUserStatus = true;
                                                                                            } else {
                                                                                                UPIUserHtml = <div className="text-danger" style={{ width: 'auto', float: 'left' }}>UPI 2.0 process {docInfo.data.userUPIResponse.response_status}.</div>;
                                                                                            }
                                                                                        }
                                                                                    }

                                                                                    return (
                                                                                        <>
                                                                                            <div className="col-md-4">
                                                                                                <b style={{ width: 'auto', float: 'left' }}>{docInfo.doc_name} {umrnNo}</b>
                                                                                            </div>
                                                                                            {UPISentStatus ? (
                                                                                                <>
                                                                                                    <div className="col-md-4">
                                                                                                        <div className="text-success" style={{ width: 'auto', float: 'left' }}>
                                                                                                            SMS link sent successfully
                                                                                                            {docInfo?.data?.createdByName !== '' && docInfo?.data?.createdByName !== undefined ? (
                                                                                                                <>
                                                                                                                    By {docInfo?.data?.createdByName}
                                                                                                                    <br />
                                                                                                                    Done on {docInfo?.data?.enach_created_date}
                                                                                                                </>
                                                                                                            ) : (
                                                                                                                ''
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="col-md-4">
                                                                                                        {UPIUserHtml}
                                                                                                    </div>
                                                                                                </>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <div className="col-md-4">
                                                                                                        <div className="col-md-8 ">
                                                                                                            {hasAddPermission && (
                                                                                                            <button style={{ margin: '0.2rem 0rem' }}
                                                                                                                type="button"
                                                                                                                className="badge btn btn-primary text-white float-right "
                                                                                                                onClick={(e) => {
                                                                                                                    e.preventDefault();
                                                                                                                    /* onSendEnachRegistrationAction(item) */
                                                                                                                    btnOpenUPIData(matchedDoc)
                                                                                                                }
                                                                                                                }
                                                                                                            >
                                                                                                                {preloaderStatus && (<>
                                                                                                                    <div className="spinner-border small-preloader d-none" role="status" >
                                                                                                                        <span className="visually-hidden">Loading...</span>
                                                                                                                    </div></>)}
                                                                                                                UPI REGISTRATION
                                                                                                            </button>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                        </>
                                                                                    );
                                                                                })()}



                                                                                {(docInfo.doc_name !== 'eNach' && docInfo.doc_name !== 'UPI 2.0') && (
                                                                                    <>
                                                                                        <div className="col-md-4" title="section 3">
                                                                                            <b>{docInfo.doc_name}</b>
                                                                                        </div>
                                                                                        <div className="col-md-4">
                                                                                            <span className={(sectionInfo === 'Sanction Letter Pending Items' || sectionInfo === 'Delivery Order Pending Items') ? "text-danger" : "text-danger"} >NOT UPLOADED</span>
                                                                                        </div>
                                                                                    </>

                                                                                )}
                                                                            </>

                                                                        </div>
                                                                    </>
                                                                )}
                                                            </>
                                                        );
                                                    })}

                                                    {hasAddPermission && sectionInfo !== 'Sanction Letter Pending Items' && sectionInfo !== 'Delivery Order Pending Items' && (
                                                        <div className="col-md-12" style={{ borderTop: "1px solid #ccc" }}>
                                                            <div className="col-md-2 mb-2" style={{ paddingTop: "15px" }}>
                                                                <button
                                                                    className="btn btn-default btn-border"
                                                                    type="button"
                                                                    style={{ width: "auto" }}
                                                                    onClick={() => {
                                                                        const validSections = [
                                                                            'Invoice',
                                                                            'Agreement',
                                                                            'Margin Money',
                                                                            'Delivery Photo',
                                                                            'Post Dated Cheque',
                                                                            'Vehicle Dedupe',
                                                                            'Disbursement' 
                                                                        ]; 
                                                                        if (validSections.includes(sectionInfo)) {
                                                                            btnUploadHandler(sectionInfo);
                                                                        }
                                                                    }}
                                                                >
                                                                    Upload More
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {(sectionInfo === 'Sanction Letter Pending Items') && allLeadCheckLists.map((item, index) => (
                                                        <>
                                                            {(item.fieldInvestigationFalg === '1') ? (
                                                                <>
                                                                    { /* 
                                 <div key={index} className="col-md-12 mb-2">
                                <b>{item.check_list_name}</b> {(item.section_name !== '') && (<> (<span
                                className={
                                    item.section_name === 'Lead'
                                        ? 'text-green'
                                        : item.section_name === 'Guarantor'
                                            ? 'text-primary'
                                            : 'text-warning'
                                }
                            >{(item.section_name === 'Lead') ? "Applicant" : item.section_name}</span> - {item.checklist_user_name})</>)}
                                    &nbsp; - Verified by system
                                </div>
                            */}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div key={index} className="col-md-12 mb-2 row">
                                                                        <div className="col-md-4" title="section 4">
                                                                            <b>{item.check_list_name}</b>

                                                                            {(item.section_name !== '') && (<> (<span
                                                                                className={
                                                                                    item.section_name === 'Lead'
                                                                                        ? 'text-green'
                                                                                        : item.section_name === 'Guarantor'
                                                                                            ? 'text-primary'
                                                                                            : 'text-warning'
                                                                                }
                                                                            >{(item.section_name === 'Lead') ? "Applicant" : item.section_name}</span>   {item.checklist_user_name})</>)}
                                                                        </div>

                                                                        <div className="col-md-4">
                                                                            <span className="text-danger">NOT VERIFIED</span>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}

                                                        </>
                                                    ))}


                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}

                        </div>



                    </div>
                </div>

{ /* Submit For Disbursement : start */ }
{(userRoleType === "User" ) ? (
showSubmitForDisbursementNote !== "" ? (
<div className="text-end">{showSubmitForDisbursementNote}</div>
) : ( 
<div>
     
    {hasEditPermission && (
        <div className="col-md-12 py-2">
        <div className="form-group text-end mb-2">
            <button
            className="btn btn-primary"
            onClick={() => handleBtnCredit('submit_for_disbursement')}
            disabled={leadId === "" || props.leadStatusFlag === true}
            >
            {" "}
            Submit for Disbursement
            </button>
        </div>
        </div>
    )}
    
</div>
)
) : ( 
showSubmitForDisbursementNote !== "" && (
<div className="text-end">{showSubmitForDisbursementNote}</div>
)
)}
{ /* Submit For Disbursement End */ }


{ /* Submit For Disbursement : start */ }
{(userRoleType === "Credit Operations" ) ? (
showDisbursedNote !== "" ? (
<div className="text-end">{showDisbursedNote}</div>
) : ( 
<div>
     
    {hasEditPermission && (
        <div className="col-md-12 py-2">
        <div className="form-group text-end mb-2">
            <button
            className="btn btn-primary"
            onClick={() => handleBtnCredit('disbursed')}
            disabled={leadId === "" || props.leadStatusFlag === true}
            >
            {" "}
            Disbursed
            </button>
        </div>
        </div>
    )}
    
</div>
)
) : ( 
showDisbursedNote !== "" && (
<div className="text-end">{showDisbursedNote}</div>
)
)}
{ /* Submit For Disbursement End */ }


            </div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Lead Document</h4>
                    </div>

                    <div className='modal-body'>
                        <div className='row mb-2 pb-1'>
                            <div className='col-1'>&nbsp;</div>
                            <div className='col-10 ps-0'>{viewModalInfo.note}</div>
                        </div>
                    </div>
                </div>
            </Modal>


            <Modal
                open={openAmt}
                onClose={handleCloseAmt}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">What is the proposed EMI amount?</h4>
                        <Button onClick={handleCloseAmt} color="primary" className=' btn'>
                            <i className="bi bi-x">&nbsp;</i>
                        </Button>
                    </div>

                    <div className='modal-body'>
                        <div>
                            <form onSubmit={handleSubmit(handleFormSubmit)} encType="multipart/form-data">
                                <div className="row mx-0">
                                    <div className="col-md-6 px-0">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>EMI Amount <a style={{ color: "red" }}>*</a></span>
                                                <input type='number' id='emi_amount' name='emi_amount'
                                                    className='form-control' {...register('emi_amount')}
                                                    onChange={handleAmtChange} />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>Debit Date <a style={{ color: "red" }}>*</a></span>
                                                <input type='date' id='debit_date' name='debit_date'
                                                    className='form-control' {...register('debit_date')}
                                                    onChange={handleDebitDateChange} />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 px-0">
                                        <div className="form-group mb-0">
                                            <button className="btn btn-primary mt-2">
                                                Submit
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* UPI REGISTRATION MODAL START */}
            <Modal open={openUPIAmt} onClose={handleCloseUPIAmt} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">UPI Amount </h4>
                        <Button onClick={handleCloseUPIAmt} color="primary" className='btn'>
                            <i className="bi bi-x"> &nbsp;</i>
                        </Button>
                    </div>

                    <div className='modal-body'>
                        <form onSubmit={handleSubmit(handleUPIFormSubmit)} encType="multipart/form-data">
                            <div className="row mx-0">

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="itr_file">
                                            <span>UPI Amount <a style={{ color: "red" }}>*</a></span>
                                            <input type='number' id='emi_amount1' name='emi_amount1' className='form-control'
                                                {...register('emi_amount1')} onChange={handleAmtUPIChange} />
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="itr_file">
                                            <span>Debit Date <a style={{ color: "red" }}>*</a></span>
                                            <input type='date' id='upi_debit_date1' name='debit_date1' className='form-control' {...register('debit_date1')} onChange={handleUPIDateChange} />
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group mb-0">
                                        <button className="btn btn-primary mt-2">
                                            UPI REGISTRATION NOW
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
            {/* UPI REGISTRATION MODAL END */}

            {/* Reject REGISTRATION MODAL START */}
            <Modal open={openRejectAmt} onClose={handleCloseRejectAmt} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title"> { /* Enter Notes */} </h4>
                        <Button onClick={handleCloseRejectAmt} color="primary" className='btn'>
                            <i className="bi bi-x"> &nbsp;</i>
                        </Button>
                    </div>

                    <div className='modal-body'>
                        <form onSubmit={handleSubmit(handleDocumentsFormSubmit)} encType="multipart/form-data" ref={formRef}>
                            <div className="row guarantor" id="bank_statement-1">

                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <label htmlFor="document-type">
                                            <span>Document Type <a style={{ color: "red" }}>*</a></span>
                                            <select disabled={props.leadStatusFlag === true} id='document_type' className="form-select" name='document_type' {...register('document_type')}>
                                                {(uploadBtnAction === 'Agreement') ? (
                                                    <>
                                                        <option value='Agreement'>Agreement </option>
                                                    </>
                                                ) : (
                                                    <>

                                                        {(uploadBtnAction === 'Margin Money') ? (
                                                            <>
                                                                <option value='Receipt'>Receipt</option>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {(uploadBtnAction === 'Delivery Photo') ? (
                                                                    <>
                                                                        <option value='Delivery Photo'>Delivery Photo</option>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {(uploadBtnAction === 'Disbursement') ? (
                                                                            <>
                                                                                <option value='Disbursement'>Disbursement</option>

                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                               {(uploadBtnAction === 'Vehicle Dedupe') ? (
                                                                            <>
                                                                                <option value='Chasis Number'>Chasis Number</option>
                                                                                <option value='Engine Number'>Engine Number</option>

                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                            {(uploadBtnAction === 'Post Dated Cheque') ? (
                                                                            <>
                                                                                <option value='Cheque Number'>Cheque Number</option> 
                                                                            </>
                                                                        ) : (

                                                                            <>
                                                                                <option value='Box Invoice'>Box Invoice </option>
                                                                                <option value='Vehicle Invoice'>Vehicle Invoice </option>


                                                                            </>
                                                                        )}
                                                                        </>
                                                                                                                                            )}


                                                                            </>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </>
                                                        )}

                                                    </>
                                                )}
                                            </select>
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="document_file">
                                            <span>File Upload <a style={{ color: "red" }}>*</a></span>
                                            <input disabled={props.leadStatusFlag === true} type='file' id='document_file' name='document_file' className='form-control' onChange={handleDocumentFileChange} />
                                        </label>
                                    </div>
                                </div>

                                <div className={uploadBtnAction === 'MSME Certificate' ? "col-md-6" : "col-md-6 d-none"} >
                                    <div className="form-group">
                                        <label htmlFor="registration_no">
                                            <span>Registration No <a style={{ color: "red" }}>*</a></span>
                                            <input readOnly={props.leadStatusFlag === true}
                                                type='text'
                                                id='registration_no'
                                                name='registration_no'
                                                className='form-control'
                                                {...register('registration_no')}
                                            />
                                        </label>
                                    </div>
                                </div>

                                <div className={uploadBtnAction === 'Vehicle Dedupe' ? "col-md-6" : "col-md-6 d-none"} >
                                    <div className="form-group">
                                        <label htmlFor="vehicle_dedupe_no">
                                            <span>Enter No <a style={{ color: "red" }}>*</a></span>
                                            <input readOnly={props.leadStatusFlag === true}
                                                type='text'
                                                id='vehicle_dedupe_no'
                                                name='vehicle_dedupe_no'
                                                className='form-control'
                                                {...register('vehicle_dedupe_no')}
                                            />
                                        </label>
                                    </div>
                                </div>

                                <div className={uploadBtnAction === 'Post Dated Cheque' ? "col-md-6" : "col-md-6 d-none"} >
                                    <div className="form-group">
                                        <label htmlFor="cheque_no">
                                            <span>Enter No <a style={{ color: "red" }}>*</a></span>
                                            <input readOnly={props.leadStatusFlag === true}
                                                type='text'
                                                id='cheque_no'
                                                name='cheque_no'
                                                className='form-control'
                                                {...register('cheque_no')}
                                            />
                                        </label>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="cheque_account_no">
                                            <span>Account No <a style={{ color: "red" }}>*</a></span>
                                            <input readOnly={props.leadStatusFlag === true}
                                                type='text'
                                                id='cheque_account_no'
                                                name='cheque_account_no'
                                                className='form-control'
                                                {...register('cheque_account_no')}
                                            />
                                        </label>
                                    </div>
                                </div>




                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <label htmlFor="document_note">
                                            <span>Notes <a style={{ color: "red" }}>*</a></span>
                                            <textarea readOnly={props.leadStatusFlag === true}
                                                id='document_note'
                                                className='form-control'
                                                placeholder="Type Something" {...register('document_note')}
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group mb-0">
                                        <button disabled={props.leadStatusFlag === true} className="btn btn-primary">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
            {/* Reject REGISTRATION MODAL END */}
        </>
    );
}


function mapStateToProps(state) {
    return {
        usersData: state.usersData,
        getUserModuleData: state.getUserModuleData,
        getUploadLeadDocument: state.getUploadLeadDocument,
        masterDocumentTypeData: state.masterDocumentTypeData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(userActions.default, leadActions.default), dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(DisbursementStage);
